export function parseBibTex(input) {
    const entries = input.split('}').filter(entry => entry.trim() !== '');

    const typeKeyMatch = entries[0].match(/@(\w+)\{([^,]+)/);
    if (!typeKeyMatch) return null;

    const type = typeKeyMatch[1];
    const key = typeKeyMatch[2];
    const parsedEntries = {}

    entries.forEach(entry => {
        entry += '}';
        const fieldMatches = entry.match(/\b(\w+)\s*=\s*\{([^}]*)\}/g);

        if (fieldMatches) {
            fieldMatches.forEach(match => {
                const parts = match.match(/\b(\w+)\s*=\s*\{([^}]*)\}/);
                if (parts && parts.length === 3) {
                    const fieldName = parts[1].trim();
                    let fieldValue = parts[2].trim();
                    fieldValue = fieldValue.replace(/^\{|\}$/g, '').trim();
                    parsedEntries[fieldName] = fieldValue;
                }
            });
        }
    });

    return { type, key, ...parsedEntries };;
}

export function bibtexToIEEE(bibtex) {
    // Function to extract fields from BibTeX
    function getField(field, entry) {
        const regex = new RegExp(`${field}\\s*=\\s*{([^}]*)}`, 'i');
        const match = entry.match(regex);
        return match ? match[1].replace(/[\n\t]/g, ' ').trim() : '';
    }

    // Parse the BibTeX entry
    const entryTypeMatch = bibtex.match(/@(\w+){/);
    const entryType = entryTypeMatch ? entryTypeMatch[1].toLowerCase() : '';
    // const citationKeyMatch = bibtex.match(/@\w+{([^,]*)/);
    // const citationKey = citationKeyMatch ? citationKeyMatch[1].trim() : '';

    // Extract common fields
    const author = getField('author', bibtex);
    const title = getField('title', bibtex);
    const journal = getField('journal', bibtex);
    const year = getField('year', bibtex);
    const volume = getField('volume', bibtex);
    const number = getField('number', bibtex);
    const pages = getField('pages', bibtex);
    const month = getField('month', bibtex);
    const doi = getField('doi', bibtex);

    // Format the authors according to IEEE style
    const formattedAuthors = author.split(' and ').map(name => {
        const parts = name.trim().split(',');
        return parts.length > 1 ? `${parts[1].trim()} ${parts[0].trim()}` : name.trim();
    }).join(', ');

    // Create the IEEE citation
    let ieeeCitation = '';

    switch (entryType) {
        case 'article':
            ieeeCitation = `${formattedAuthors}, "${title}," *${journal}*, vol. ${volume}, no. ${number}, pp. ${pages}, ${month} ${year}.`;
            break;
        case 'book':
            const publisher = getField('publisher', bibtex);
            ieeeCitation = `${formattedAuthors}, *${title}*. ${publisher}, ${year}.`;
            break;
        case 'inproceedings':
            const booktitle = getField('booktitle', bibtex);
            ieeeCitation = `${formattedAuthors}, "${title}," in *${booktitle}*, ${year}.`;
            break;
        // Add more cases as needed for other BibTeX types
        default:
            ieeeCitation = `${formattedAuthors}, "${title}," ${year}.`;
            break;
    }

    // Add DOI if available
    if (doi) {
        ieeeCitation += ` DOI: ${doi}.`;
    }

    return ieeeCitation;
}
